import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { immerable } from 'immer';
import { OrderedSet } from 'immutable';

interface IConnectorItemEntity {
	id: number;
	code: string;
	label: string;
	type: string;
	mode: string;
	isActive: boolean;
	isImported: boolean;
	description: string;
	tags: OrderedSet<AppTagItemEntity>;
	updateDate: Date | null;
	updatedBy: string;
	creationDate: Date | null;
	createdBy: string;
	updatedByAvatar: AvatarEntity | null;
	createdByAvatar: AvatarEntity | null;
	pictogramUrl: string;
	depotsCount: number;
}

const entityDefaults: IConnectorItemEntity = {
	id: -1,
	label: '',
	code: '',
	description: '',
	tags: OrderedSet(),
	updateDate: null,
	updatedBy: '',
	creationDate: null,
	createdBy: '',
	isActive: false,
	updatedByAvatar: null,
	createdByAvatar: null,
	pictogramUrl: '',
	isImported: false,
	depotsCount: 0,
	type: '',
	mode: 'READ_WRITE',
};

export class ConnectorItemEntity implements IConnectorItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public code = entityDefaults.code;
	public description = entityDefaults.description;
	public label = entityDefaults.label;
	public tags = entityDefaults.tags;
	public updateDate = entityDefaults.updateDate;
	public updatedBy = entityDefaults.updatedBy;
	public creationDate = entityDefaults.creationDate;
	public createdBy = entityDefaults.createdBy;
	public isActive = entityDefaults.isActive;
	public updatedByAvatar = entityDefaults.updatedByAvatar;
	public createdByAvatar = entityDefaults.createdByAvatar;
	public pictogramUrl = entityDefaults.pictogramUrl;
	public isImported = entityDefaults.isImported;
	public depotsCount = entityDefaults.depotsCount;
	public type = entityDefaults.type;
	public mode = entityDefaults.mode;

	public static build(
		params: Partial<IConnectorItemEntity> = {}
	): ConnectorItemEntity {
		const entity = new ConnectorItemEntity();
		entity.id = params.id ?? entityDefaults.id;
		entity.code = params.code ?? entityDefaults.code;
		entity.description = params.description ?? entityDefaults.description;
		entity.label = params.label ?? entityDefaults.label;
		entity.tags = params.tags ?? entityDefaults.tags;
		entity.updateDate = params.updateDate ?? entityDefaults.updateDate;
		entity.updatedBy = params.updatedBy ?? entityDefaults.updatedBy;
		entity.creationDate = params.creationDate ?? entityDefaults.creationDate;
		entity.createdBy = params.createdBy ?? entityDefaults.createdBy;
		entity.isActive = params.isActive ?? entityDefaults.isActive;
		entity.isImported = params.isImported ?? entityDefaults.isImported;
		entity.createdByAvatar =
			params.createdByAvatar ?? entityDefaults.createdByAvatar;
		entity.depotsCount = params.depotsCount ?? entityDefaults.depotsCount;
		entity.pictogramUrl = params.pictogramUrl ?? entityDefaults.pictogramUrl;
		entity.type = params.type ?? entityDefaults.type;
		entity.mode = params.mode ?? entityDefaults.mode;
		if (params.updatedBy) {
			entity.updatedByAvatar = AvatarEntity.build(params.updatedBy);
		}
		if (params.createdBy) {
			entity.createdByAvatar = AvatarEntity.build(params.createdBy);
		}
		return entity;
	}
}
